import active from './active';
import defaultState from './default';
import hover from './hover';

export default {
  active,
  default: defaultState,
  hover,
};
